import React, { ReactNode, useState } from "react";
import Size from "../../../../Layout/Size";
import * as Styled from "./StickyTextInput.styled";

export interface StickyTextInputProps {
	prefix?: string;
	suffix?: string;
	style?: React.CSSProperties;
	value?: string | number;
	showValue?: boolean;
	hiddenLabel?: boolean;
	children?: ReactNode;
}

/** Only pass in a Form.Field component that uses a plain text input. This isn't built to handle anything else. */
const StickyTextInput: React.FC<StickyTextInputProps> = ({
	hiddenLabel = false,
	prefix,
	suffix,
	style,
	value,
	showValue,
	children,
}) => {
	const [prefixSize, setPrefixSize] = useState(0);
	return (
		<>
			<Styled.StickyInput prefixSize={prefixSize} hiddenLabel={hiddenLabel} style={style}>
				{prefix && (
					<p className="mask">
						<Size
							element={<span className="prefix">{prefix}</span>}
							onSize={(size) => setPrefixSize(size.width as number)}
						></Size>
						<span className={showValue ? "show" : ""}>{value}</span>
						{suffix && <span className="suffix">{suffix}</span>}
					</p>
				)}

				{children}
			</Styled.StickyInput>
		</>
	);
};

export default StickyTextInput;
